import { configureStore } from '@reduxjs/toolkit';
import authReducer, { initialAuthState } from './slices/authSlice';
import mainReducer from './slices/mainSlice';
import adminReducer, {initialAdminState} from './slices/adminSlice';
import { api } from "../api/api";
import { middleware } from "./middleware/apiMiddleware";

const loadAuthReducer = () => {
  const result = initialAuthState;
  const projects = localStorage.getItem("projects");
  if (!!projects) {
    result.projects = JSON.parse(projects);
  }

  const isProjectAdmin = localStorage.getItem("isProjectAdmin");
  if (!!isProjectAdmin) {
    result.isProjectAdmin = +isProjectAdmin === 1;
  }

  const isTestToolAdmin = localStorage.getItem("isTestToolAdmin");
  if (!!isTestToolAdmin) {
    result.isTestToolAdmin = +isTestToolAdmin === 1;
  }

  const login = localStorage.getItem("login");
  if (!!login) {
    result.login = login;
  }

  result.userToken = localStorage.getItem("userToken") || "";

  return result;
}

const loadAdminReducer = () => {
  const result = initialAdminState;
  const sortAdminTable = localStorage.getItem("sortAdminTable");
  if (!!sortAdminTable) {
    result.sortAdminTable = JSON.parse(sortAdminTable);
  }
  const showDelete = localStorage.getItem("showDelete");
  if (!!showDelete) {
    result.showDelete = +showDelete === 1
  }

  return result;
}

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,

    authReducer,
    mainReducer,
    adminReducer

  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ immutableCheck: false }).concat(
      middleware
    ),
  preloadedState: {
    authReducer: loadAuthReducer(),
    adminReducer: loadAdminReducer()
  }
});

store.subscribe(() => {
  const state = store.getState();

  const authReducer = state.authReducer;
  if (!!authReducer.userToken) {
    localStorage.setItem("userToken", authReducer.userToken);
  } else {
    localStorage.removeItem("userToken");
  }
  localStorage.setItem("projects", JSON.stringify(authReducer.projects));
  localStorage.setItem("isProjectAdmin", authReducer.isProjectAdmin ? "1" : "0");
  localStorage.setItem("isTestToolAdmin", authReducer.isTestToolAdmin ? "1" : "0");
  authReducer.login && localStorage.setItem("login", authReducer.login);

  const adminReducer = state.adminReducer;
  localStorage.setItem("sortAdminTable", JSON.stringify(adminReducer.sortAdminTable));
  localStorage.setItem("showDelete", adminReducer.showDelete ? "1" : "0");
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;